import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconWiggot from '../build/icon-wiggot'

export const IconWiggot: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconWiggot} />
}

export default IconWiggot
